import { render, staticRenderFns } from "./DeclinedAlert.vue?vue&type=template&id=278406ae"
import script from "./DeclinedAlert.vue?vue&type=script&lang=js"
export * from "./DeclinedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports